import PropTypes from "prop-types";

import Tooltip from "@shared/v2/Tooltip/Tooltip";
import { Popover, PopoverContent, PopoverTrigger } from "@shared/v2/Popover";
import { CaretDownSolidV6 } from "@shared/v2/Icomoon";

const IconDropdown = ({ icon, tooltip, editable, children, hideDropdown }) => {
  const popoverCaret = (
    <span className="tw-pl-[4px]">
      <CaretDownSolidV6 className={editable ? "" : "tw-opacity-60"} />
    </span>
  );

  return (
    <>
      <Tooltip placement="top" content={tooltip} trigger={icon} innerClassName="tw-max-w-[200px]" />
      {!editable && popoverCaret}
      {editable && (
        <Popover placement="bottom-start" offset={0}>
          {!hideDropdown && <PopoverTrigger>{popoverCaret}</PopoverTrigger>}
          <PopoverContent>{children}</PopoverContent>
        </Popover>
      )}
    </>
  );
};

IconDropdown.propTypes = {
  editable: PropTypes.bool,
  hideDropdown: PropTypes.bool,
  children: PropTypes.func,
  tooltip: PropTypes.string,
  icon: PropTypes.func,
};

IconDropdown.defaultValue = {
  editable: true,
  hideDropdown: false,
  children: null,
  tooltip: null,
  icon: null,
};

export default IconDropdown;
